module.exports = "# Song\nYouTube: fB3ZHt6aYJ8\n\n## Notes\n\n### Emergency Preparedness Squad Song\n\nEncourage your class to learn this song and sing along to the video (2:21).\n\n### Extension Activities\nApprentices can perform the song to the whole school and/or create their own choreography.\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsPrimaries/sections/03_song/song.md
// module id = 1629
// module chunks = 2